export default str => {
	if (typeof str == 'string') {
		try {
			let obj = JSON.parse(str);
			return !!(typeof obj == 'object' && obj);
		} catch (e) {
			return false;
		}
	}else {
	    return false
    }
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/isJsonStr.js